window.addEventListener('DOMContentLoaded', function () {
  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const el = entry.target;
        const content = el.querySelector('p');
        if (!content) return;

        const text = content.textContent?.trim().replace('%', '') || '0';
        const target = parseInt(text, 10);
        if (isNaN(target)) return;

        let current = 0;

        const interval = setInterval(() => {
          current = current + 3;
          content.textContent = `${current}%`;
          if (current >= target) { clearInterval(interval); content.textContent = `${target}%`; };
        }, 0.5);

        // Unobserve after triggering once
        observer.unobserve(el);
      }
    });
  }, { threshold: 0.3 }); // start when 30% visible

  document.querySelectorAll('[number-count]').forEach(el => observer.observe(el));
});